import React from 'react';
import { Box } from '@mui/material';

export default function SplashScreen({ show }) {
  return (
    <Box
      sx={{
        position: 'fixed',
        inset: 0,
        zIndex: 2000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#f1f5f9',
        opacity: show ? 1 : 0,
        pointerEvents: show ? 'all' : 'none',
        transition: 'opacity 0.55s ease',
      }}
    >
      <Box
        component="img"
        src={`${process.env.PUBLIC_URL}/images/fulfillment-splash.png`}
        alt="Loading"
        sx={{ width: '100%', maxWidth: 680, objectFit: 'contain' }}
      />
    </Box>
  );
}
